<main [@fadeInOut] id="main-heading" role="main" tabindex="0">
  <div class="col-sm-11 center-block">
    <div class="row">
        <div class="col-md-12">
            <h1 tabindex="0" aria-label="Contacts" role="heading" aria-level="1">Contacts</h1>
            <p role="paragraph" tabindex="0" aria-label="Contact Dashboard Introduction">
                Maintain and store your entire portfolio of contacts in a single location. Enter once and reuse many times.
                Locate your contacts in the grid below or click search options to update a stored contact. Click 'Create new contact' to create a new contact for use.
            </p>
            <p id="demo"></p>
        </div>
    </div>
    <div class="row top-space">
        <div class="col-sm-12 top-space">
            <nav ngbNav #ngbNav="ngbNav" [(activeId)]="activeTab" (navChange)="tabChanged($event)" tabindex="0" class="nav-tabs">
                <ng-container ngbNavItem="contact">
                    <a ngbNavLink>
                        <span aria-label="Contacts">Contacts ({{ count_contact }})</span>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="row bottom-padding">
                            <div class="col-sm-12">
                              <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)" target=".e-tooltipcolumn" [enableHtmlParse]="false">
                                <ejs-grid id='contactGrid' #contact_grid [dataSource]='contact_grid_data' allowPaging='true'
                                          allowSorting='true' [pageSettings]='initialPage' height="570" allowScrolling="true"
                                          [toolbar]='toolbarOptions' (toolbarClick)='toolbarClick($event)'
                                          allowFiltering="true" (actionBegin)=begin($event)
                                          (rowSelected)="contactGridRowSelected($event)" (rowDeselected)="contactGridRowDeselected($event)" 
                                          [selectionSettings]="{ type: 'Single', persistSelection: true }">
                                  <e-columns>
                                    <!-- Hidden stable primary key used by persistSelection -->
                                    <e-column [customAttributes]="clipmodecolumn" field='contactRevisionId' isPrimaryKey="true" [visible]="false" [allowFiltering]="false" [allowSorting]="false"></e-column>

                                    <e-column type="checkbox" width="40" *ngIf="hasDeletePermission"></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='contactName' headerText='Contact Name' width='350' clipMode="EllipsisWithTooltip">
                                      <ng-template #template let-contact_grid_data>
                                        <a class='pointer' (click)='viewContact(contact_grid_data.contactRevisionId, contact_grid_data.contactId)'
                                           tabindex="0" role="link" aria-label="View Contact" (keydown.enter)="viewContact(contact_grid_data.contactRevisionId, contact_grid_data.contactId)">{{contact_grid_data.contactName}}</a>
                                      </ng-template>
                                    </e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='status$' headerText='Status' width='150'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='version' headerText='Version' type="number" format="N1" clipMode="EllipsisWithTooltip" width='150'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='createdBy' headerText='Created By' clipMode="EllipsisWithTooltip" width='250'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='modified' headerText='Last Modified Date' type="date" [format]='formatOptions' [allowFiltering]="false" clipMode="EllipsisWithTooltip" width='200'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='modifiedBy' headerText='Modified By' clipMode="EllipsisWithTooltip" width='250'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='businessCategory' headerText='Business Category' clipMode="EllipsisWithTooltip" width='150'></e-column>
                                  </e-columns>
                                </ejs-grid>
                              </ejs-tooltip>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
                <ng-container ngbNavItem="drafts">
                    <a ngbNavLink>
                        <span aria-label="Drafts">Drafts ({{ count_drafts }})</span>
                    </a>
                    <ng-template ngbNavContent>
                        <div class="row bottom-padding">
                            <div class="col-sm-12">
                              <ejs-tooltip #tooltip id="tooltip" (beforeRender)="tooltipValue($event)" target=".e-tooltipcolumn" [enableHtmlParse]="false">
                                <ejs-grid id='draftsGrid' #drafts_grid [dataSource]='drafts_grid_data' allowPaging='true'
                                          allowSorting='true' [pageSettings]='initialPage' height="570" (actionBegin)=begin($event)
                                          [toolbar]='toolbarOptions' (toolbarClick)='toolbarClick($event)' allowScrolling="true"
                                          allowFiltering="true" (rowSelected)="contactGridRowSelected($event)" (rowDeselected)="contactGridRowDeselected($event)" 
                                           [selectionSettings]="{ type: 'Single', persistSelection: true }">
                                  <e-columns>
                                    <!-- Hidden stable primary key used by persistSelection -->
                                    <e-column [customAttributes]="clipmodecolumn" field='contactRevisionId' isPrimaryKey="true" [visible]="false" [allowFiltering]="false" [allowSorting]="false"></e-column>

                                    <e-column type="checkbox" width="40" *ngIf="hasDeletePermission"></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='contactName' headerText='Contact Name' width='120' clipMode="EllipsisWithTooltip">
                                      <ng-template #template let-drafts_grid_data>
                                        <a class='pointer' (click)='viewContact(drafts_grid_data.contactRevisionId, drafts_grid_data.contactId)'
                                           tabindex="0" role="link" aria-label="View Contact" (keydown.enter)="viewContact(drafts_grid_data.contactRevisionId, drafts_grid_data.contactId)">{{drafts_grid_data.contactName}}</a>
                                      </ng-template>
                                    </e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='status' headerText='Status' width='150'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='createdBy' headerText='Created By' clipMode="EllipsisWithTooltip" width='85'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='modified' headerText='Last Modified Date' type="date" [format]='formatOptions' [allowFiltering]="false" clipMode="EllipsisWithTooltip" width='120'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='modifiedBy' headerText='Modified By' clipMode="EllipsisWithTooltip" width='80'></e-column>
                                    <e-column [customAttributes]="clipmodecolumn" field='businessCategory' headerText='Business Category' clipMode="EllipsisWithTooltip" width='100'></e-column>
                                  </e-columns>
                                </ejs-grid>
                              </ejs-tooltip>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </nav>
            <div [ngbNavOutlet]="ngbNav"></div>
        </div>
    </div>
    <div *ngIf="loading">
        <div id="loading"></div>
    </div>
    <div *ngIf="hasDeletePermission" class="col-sm-12 grid-actions">
        <app-delete-button #deleteContact
            class="hide-element"
            [canDelete]="!!selectedContactRevisionId"
            [revisionId]="selectedContactRevisionId"
            [apiController]="'Contacts'"
            [isDraft]="false"
        ></app-delete-button>
    </div>
    <div *ngIf="hasDeletePermission" class="col-sm-12 grid-actions">
        <app-delete-button #deleteDraftContact
            class="hide-element"
            [canDelete]="!!selectedContactRevisionId"
            [revisionId]="selectedContactRevisionId"
            [apiController]="'Contacts'"
            [isDraft]="true"
        ></app-delete-button>
    </div>
  </div>
</main>

